import React from "react"

export const Elixir = ({ count }) => {
  return (
    <div className="elixir">
      <img className="elixirImage" src="https://vignette.wikia.nocookie.net/clashroyale/images/4/43/Elixir.png/revision/latest/scale-to-width-down/50" alt={count}></img>
      <div className="elixirCount">{count}</div>
    </div>
  )
}
